import type { Components, Theme } from '@mui/material';

export const MuiToggleButton: Components<Theme>['MuiToggleButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      textTransform: 'none',
      flexDirection: 'column',
      alignItems: 'flex-start',
      textAlign: 'left',
      width: '100%',
      color: theme.palette.neutral.darker,
      padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
      backgroundColor: `${theme.palette.neutral[0]} !important`,
      '&:hover': {
        backgroundColor: `${theme.palette.neutral.lighter} !important`,
      },
      '&:active': { backgroundColor: theme.palette.neutral.light },
    }),
  },
};
